import React from 'react';
import { withRouter } from 'react-router';
import { Button, Card, CardContent } from '@material-ui/core';
import { toast } from 'react-toastify';
import Framework from '@beardeddevops/react.framework';
import Types from 'constants/Types';
import API from '@beardeddevops/react.api';
import {
	fetchQuickPickList,
	removeQuickPick,
	reorderQuickPicks,
} from '../../utils/checkoutQuickPicks';
import '../Parts/QuickCheckout.scss';

class AccountQuickCheckout extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Accounts_Customizations._name);
		this.noDelete = false;
		this.state.favorites = [];
		this.state.favoritesLoading = false;
	}

	componentDidMount() {
		if (super.componentDidMount) {
			super.componentDidMount();
		}
		void this.loadFavorites();
	}

	loadSelfAfter = (data) => {
		this.setState({
			quick_checkout_enabled: !!data.quick_checkout_enabled,
		});
		if (data.quick_checkout_enabled) {
			void this.loadFavorites();
		}
	};

	loadFavorites = async () => {
		this.setState({ favoritesLoading: true });
		try {
			const favorites = await fetchQuickPickList();
			this.setState({ favorites, favoritesLoading: false });
		} catch (error) {
			this.setState({ favorites: [], favoritesLoading: false });
		}
	};

	saveQuickCheckoutEnabled = async (enabled) => {
		const model = new API.BuildClass(Types.Accounts_Customizations._name, API.RequestType.UPDATE);
		model.object = {
			pkey: this.state.pkey,
			quick_checkout_enabled: enabled,
		};
		await model.submit(null, API.RequestType.UPDATE);
		this.setState({ quick_checkout_enabled: enabled });
		if (this.props.rootState && this.props.rootState.set) {
			this.props.rootState.set({ quick_checkout_enabled: enabled });
		}
	};

	handleQuickCheckoutToggle = async (property, value) => {
		const enabled = !!value;
		const previous = !!this.state.quick_checkout_enabled;
		if (enabled === previous) {
			return;
		}

		this.setState({ quick_checkout_enabled: enabled });
		try {
			await this.saveQuickCheckoutEnabled(enabled);
			if (enabled) {
				await this.loadFavorites();
			} else {
				this.setState({ favorites: [] });
			}
		} catch (error) {
			this.setState({ quick_checkout_enabled: previous });
			toast.error('Could not update Quick Checkout setting.', { position: toast.POSITION.TOP_RIGHT });
		}
	};

	moveFavorite = async (index, direction) => {
		const favorites = [...this.state.favorites];
		const targetIndex = index + direction;
		if (targetIndex < 0 || targetIndex >= favorites.length) {
			return;
		}

		const [item] = favorites.splice(index, 1);
		favorites.splice(targetIndex, 0, item);
		this.setState({ favorites });

		try {
			await reorderQuickPicks(favorites);
		} catch (error) {
			toast.error('Could not reorder favorites.', { position: toast.POSITION.TOP_RIGHT });
			await this.loadFavorites();
		}
	};

	handleRemoveFavorite = async (item) => {
		try {
			await removeQuickPick(item.pkey);
			await this.loadFavorites();
		} catch (error) {
			toast.error('Could not remove favorite.', { position: toast.POSITION.TOP_RIGHT });
		}
	};

	form = () => {
		const properties = (this.model && this.model.properties) ? this.model.properties : {};
		const { quick_checkout_enabled, favorites, favoritesLoading } = this.state;
		const quickCheckoutProperty = properties.quick_checkout_enabled || {
			name: 'quick_checkout_enabled',
			type: 'bool',
			class: Types.Accounts_Customizations._name,
			label: 'Checkout Search',
			fill: false,
			error: '',
		};

		return (
			<div className="row">
				<div className="col-3">
					<h4 className="section-title">Quick Checkout</h4>
					<div className="form-group">
						<b>Checkout Search</b>
						<Framework.Elements.ButtonSwitch
							value={!!quick_checkout_enabled}
							error={this.state.quick_checkout_enabled_error}
							property={quickCheckoutProperty}
							update={this.handleQuickCheckoutToggle}
							labelTrue="Show"
							labelFalse="Hide"
							project={'pos'}
						/>
					</div>
					<p className="quick-checkout-settings__help">
						Show the Add to checkout search on the checkout page.
					</p>
					<p className="quick-checkout-settings__help">
						Use the star on an item or service page to add it as a favorite. Then arrange the order here.
					</p>
				</div>

				<div className="col-9">
					<h4 className="section-title">Favorites Order</h4>

					{!quick_checkout_enabled && (
						<p style={{ color: 'rgba(0,0,0,0.6)' }}>
							Enable Quick Checkout to manage favorites.
						</p>
					)}

					{quick_checkout_enabled && favoritesLoading && <p>Loading favorites...</p>}
					{quick_checkout_enabled && !favoritesLoading && favorites.length === 0 && (
						<p style={{ color: 'rgba(0,0,0,0.6)' }}>
							No favorites yet. Open an item or service and click the star to add it.
						</p>
					)}

					{quick_checkout_enabled && !favoritesLoading && favorites.map((item, index) => (
						<div key={item.pkey} className="quick-checkout-settings__favorite-row">
							<div>
								<div>{item.label}</div>
								<div className="quick-checkout-settings__favorite-meta">{item.meta}</div>
							</div>
							<div className="quick-checkout-settings__favorite-actions">
								<Button size="small" disabled={index === 0} onClick={() => this.moveFavorite(index, -1)}>
									<i className="fa fa-arrow-up" />
								</Button>
								<Button
									size="small"
									disabled={index === favorites.length - 1}
									onClick={() => this.moveFavorite(index, 1)}
								>
									<i className="fa fa-arrow-down" />
								</Button>
								<Button size="small" className="secondary-button" onClick={() => this.handleRemoveFavorite(item)}>
									Remove
								</Button>
							</div>
						</div>
					))}
				</div>
			</div>
		);
	};

	render() {
		return (
			<Card>
				<CardContent>
					{this.form()}
				</CardContent>
			</Card>
		);
	}
}

export default withRouter(Framework.Components.withRootState(AccountQuickCheckout));
